import React, {FC} from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import {TypoComponentsHeroHeader} from 'lib/api/strapi';

import {palette} from 'styles/mui/scss';

import {Box, Typography} from 'components/basic-components';
import Breadcrumb from 'components/basic-components/Breadcrumb/Breadcrumb';
import {ButtonWithConfig} from 'components/basic-components/Button/ButtonWithConfig';
import MarkdownContent from 'components/basic-components/MarkdownContent';
import {withErrorBoundary} from 'components/error/ErrorBoundary';
import ContentWrapper from 'components/layout-components/ContentWrapper/ContentWrapper';

import styles from './HeroHeader.module.scss';

const HeroHeader: FC<TypoComponentsHeroHeader> = ({
  breadcrumb,
  backgroundImageScreen,
  backgroundImageMobile,
  textColor,
  content,
  displayImageOverlay,
  imageOverlay,
  fullWidthBackgroundImage,
  backgroundColor,
  customMobileHeight,
}) => {
  const showScreenImage = useMediaQuery('(min-width:770px)');

  console.log(backgroundImageMobile?.data?.attributes?.height);

  return (
    <ContentWrapper
      className={fullWidthBackgroundImage ? styles.wrapper : null}
      sx={{
        backgroundColor: backgroundColor,
        backgroundImage: fullWidthBackgroundImage
          ? `url(${
              showScreenImage
                ? backgroundImageScreen?.data?.attributes?.url
                : backgroundImageMobile?.data?.attributes?.url
            })`
          : null,
        position: 'relative',
        paddingBottom: {
          xxs: backgroundImageMobile?.data?.attributes?.url ? '50px' : 0,
          md: backgroundImageScreen?.data?.attributes?.url ? '50px' : 0,
        },
        height: {xxs: customMobileHeight ? `${customMobileHeight}px` : '470px', md: '650px'},
      }}
    >
      <Box
        className={!fullWidthBackgroundImage ? styles.wrapper : null}
        sx={{
          backgroundImage: !fullWidthBackgroundImage
            ? `url(${
                showScreenImage
                  ? backgroundImageScreen?.data?.attributes?.url
                  : backgroundImageMobile?.data?.attributes?.url
              })`
            : null,
          color:
            textColor === 'black'
              ? palette.colorBlack
              : textColor === 'white'
              ? palette.colorWhite
              : null,
        }}
      >
        {displayImageOverlay ? (
          <Box
            sx={{
              backgroundColor:
                imageOverlay === 'strong'
                  ? palette.colorGrey50
                  : imageOverlay === 'light'
                  ? palette.colorGrey35
                  : null,
            }}
            className={styles.overlay}
          />
        ) : null}
        <Box sx={{position: 'relative'}}>
          {breadcrumb.length > 0 ? (
            <Box className={styles.breadcrumbWrapper}>
              <Breadcrumb link={breadcrumb} />
            </Box>
          ) : null}
          {content ? (
            <Box
              className={styles.contentWrapper}
              sx={{
                width: {xxs: '100%', md: `${content?.contentWidth}%`},
              }}
            >
              <Box
                sx={{
                  paddingTop: {
                    xxs:
                      content?.spacing === 'small' || content?.spacing === 'medium'
                        ? '20px'
                        : content?.spacing === 'large'
                        ? '50px'
                        : null,
                    md:
                      content?.spacing === 'small'
                        ? '20px'
                        : content?.spacing === 'medium'
                        ? '50px'
                        : content?.spacing === 'large'
                        ? '100px'
                        : null,
                    xxl:
                      content?.spacing === 'small'
                        ? '20px'
                        : content?.spacing === 'medium'
                        ? '100px'
                        : null,
                  },
                }}
              >
                {content?.tag ? (
                  <Typography className={styles.tag}>{content?.tag}</Typography>
                ) : null}

                <Typography
                  className={styles.title}
                  variant="teaser"
                  component={content?.titleLevel}
                >
                  {content?.title}
                </Typography>
              </Box>
              <MarkdownContent className={styles.markdown} content={content?.text} />
              <Box sx={{display: 'flex', gap: '16px'}}>
                <ButtonWithConfig
                  buttonProps={content?.button}
                  variant={textColor === 'black' ? 'inverted' : 'contained'}
                />
                {content?.buttonSecondary ? (
                  <ButtonWithConfig
                    buttonProps={content?.buttonSecondary}
                    variant={textColor === 'black' ? 'inverted' : 'contained'}
                  />
                ) : null}
              </Box>
            </Box>
          ) : null}
        </Box>
      </Box>
    </ContentWrapper>
  );
};

export default withErrorBoundary(HeroHeader, ' HeroHeader');
